import { dropdownTriggerClassname } from "app/components/Dropdown";
import MemberProfileAvatar from "app/components/MemberProfileAvatar";
import CustomTooltip from "app/components/Tooltip";
import MemberSelection from "app/containers/Features/components/MemberSelection";
import { filterActiveTeamMembers } from "app/containers/Features/components/MemberSelection/helper";
import { selectProjectMemberList } from "app/containers/Features/components/MemberSelection/redux/selector";
import {
  IMemberList
} from "app/containers/Features/components/MemberSelection/types";
import clsx from "clsx";
import React from "react";
import { useSelector } from "react-redux";

interface AssigneeSelectionProps {
  assignedTo: string;
  onUpdate: (id: string) => void;
}

const Assignee: React.FC<AssigneeSelectionProps> = ({
  assignedTo,
  onUpdate,
}) => {
  const members = useSelector(selectProjectMemberList);
  const activeTeamMembers = filterActiveTeamMembers(members);

  const updateValue = (data: IMemberList) => {
    // update form out side parent component
    onUpdate(data._id);
  };

  return (
    <div className="relative w-full ">
      <MemberSelection
        trigger={
          <button className={clsx("flex items-center hover:border !hover:border-gray-300 p-[4px] rounded-[2px] min-w-0 cursor-pointer w-full h-full overflow-hidden",dropdownTriggerClassname)}>
            <CustomTooltip
              text="Set assignee"
              className="flex items-center gap-1 w-full "
              position="left"
            >
              {assignedTo ? (
                <MemberProfileAvatar
                  id={assignedTo}
                  circleClassName="!w-6 !h-6"
                />
              ) : (
                "-"
              )}
            </CustomTooltip>
          </button>
        }
        align="center"
        selectedValue={assignedTo}
        updateValue={updateValue}
        options={activeTeamMembers}
        className=" border-secondary "
        showTooltipArrowIcon
      />
    </div>
  );
};

export default Assignee;
